module.exports = __webpack_public_path__ + "img/appdown_back.1702caef.jpg";